import I18nMessageComponent from './I18nMessageComponent';


export default I18nMessageComponent;
